import { useIntl } from 'react-intl';
import CTA from '../../atoms/CTA';
import Picture from '../../atoms/Picture';
import getImageProperties from '~/helpers/getImageProperties';
import ContentHubText from '../../atoms/Icon/icons/ContentHubText';
import ContentHubAudio from '../../atoms/Icon/icons/ContentHubAudio';
import ContentHubVideo from '../../atoms/Icon/icons/ContentHubVideo';
import {
  ContentHubColorLine,
  ContentHubContent,
  ContentHubDescription,
  ContentHubHeadline,
  ContentHubImage,
  ContentHubTopic,
  ContentHubTopicLink,
  ContentHubType,
  ContentHubTypeIcon,
  ContentHubTypeSeparator,
} from './ContentHubTeaserCard.styles';

/**
 * @param {string} mediaType
 * @returns {React.ReactElement}
 */
const getMediaTypeIcon = (mediaType) => {
  switch (mediaType) {
    case 'TEXT':
      return <ContentHubText />;
    case 'AUDIO':
      return <ContentHubAudio />;
    case 'VIDEO':
      return <ContentHubVideo />;
    default:
      return <ContentHubText />;
  }
};

/**
 * @param {ContentHubTeaserCardProps} props
 * @returns {React.ReactElement} The rendered component
 */
export function ContentHubTeaserCard({
  withPicture = true,
  inHero = false,
  format,
  description,
  image,
  mediaType,
  postType,
  title,
  topic,
  topicPageUrl,
  url,
  isContentHubCategoryPage,
}) {
  const intl = useIntl();
  const imgUrls = getImageProperties(
    {
      xl: image?.format16to9?.url || '',
      md: image?.format4to3?.url || '',
      xs: image?.format4to3?.url || '',
    },
    'contentHubTeaser',
  );
  // TO REMOVE
  const urlFix = (url || '').replace(
    'https://fresenius-karriere-development.kundenheimat.de/',
    '/',
  );

  return (
    <div data-id="content-hub-card">
      {withPicture && (
        <ContentHubImage
          inHero={inHero}
          onClick={inHero ? undefined : () => window.open(urlFix, '_self')}
        >
          <Picture
            urls={
              format === 'landscape'
                ? {
                    xl: imgUrls.xl,
                    md: imgUrls.xl,
                    xs: imgUrls.xs,
                  }
                : {
                    xl: imgUrls.md,
                    md: imgUrls.md,
                    xs: imgUrls.xs,
                  }
            }
          />
        </ContentHubImage>
      )}
      <ContentHubContent
        data-id="content-hub-card-content"
        style={
          inHero
            ? {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'end',
                textAlign: 'right',
              }
            : {}
        }
      >
        <ContentHubHeadline
          data-id="content-hub-card-headline"
          lang={intl.locale}
        >
          {inHero ? (
            <span>{title}</span>
          ) : (
            <a href={urlFix} rel="noopener noreferrer">
              {title}
            </a>
          )}
        </ContentHubHeadline>
        <ContentHubColorLine data-id="content-hub-card-colorline" />
        {description && (
          <ContentHubDescription
            data-id="content-hub-card-description"
            href={urlFix}
            rel="noopener noreferrer"
          >
            {description}
          </ContentHubDescription>
        )}
        {isContentHubCategoryPage || !topicPageUrl ? (
          <ContentHubTopic>
            <span>{topic}</span>
          </ContentHubTopic>
        ) : (
          <ContentHubTopicLink>
            <CTA
              text={topic}
              href={topicPageUrl}
              title={topic}
              skin="TERTIARY"
            />
          </ContentHubTopicLink>
        )}

        <ContentHubType>
          <span>{postType}</span>
          <ContentHubTypeSeparator> | </ContentHubTypeSeparator>
          <ContentHubTypeIcon>{getMediaTypeIcon(mediaType)}</ContentHubTypeIcon>
        </ContentHubType>
      </ContentHubContent>
    </div>
  );
}
